import {
  Avatar, IconButton, Stack, Typography,
} from '@datanomik/commons-ui';
import { LinkedIn } from '@mui/icons-material';
import CopyButton from '@/views/common/Copy/CopyButton';
import { AreaHeader } from '@/features/support/shared/area-header/AreaHeader';
import { useTranslation } from 'react-i18next';
import { AccountManagerType } from './type';

type AccountManagerRowProps = {
  manager: AccountManagerType;
}
export const AccountManagerRow = (props: AccountManagerRowProps) => {
  const { manager } = props;
  const { t } = useTranslation();

  if (!manager || !manager.name) {
    return null;
  }

  return (
    <Stack>
      <AreaHeader title={t('Your Manager')} />
      <Stack sx={{
        padding: '20px',
        paddingX: '32px',
      }}
      >
        <Stack direction="row" alignItems="stretch" gap="16px">
          <Avatar
            sx={{
              width: '64px',
              height: '64px',
            }}
            src={manager.photo}
          />
          <Stack flex={1} justifyContent="space-between">
            <Typography fontSize="16px" fontWeight="500">
              {manager.name}
            </Typography>
            <Typography fontSize="14px" color="neutral.main">
              {manager.role}
            </Typography>
            <Stack direction="row">
              <Typography fontSize="12px" color="neutral.main">
                {manager.email}
              </Typography>
              <CopyButton value={manager.email} />
            </Stack>
          </Stack>
          <Stack justifyContent="start">
            <IconButton onClick={() => window.open(manager.linkedinUrl, '_blank')}>
              <LinkedIn />
            </IconButton>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
